var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "page-header",
        {
          attrs: {
            actions: _vm.pageHeaderActionsConfig,
            "left-side-class": "col-xl-4 pb-2",
            page: _vm.headerConfig,
            "right-side-class":
              "col-xl-8 align-items-end d-flex pb-4 justify-content-end"
          }
        },
        [
          _vm.anyChecked
            ? _c("drop-down", {
                staticClass: "actions-dropdown pt-2 text-black",
                attrs: {
                  "always-show-dropdown": "",
                  items: _vm.checkedActions,
                  "normal-size": ""
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.isDenying
        ? _c(
            "div",
            { staticClass: "row bg-secondary-3 p-3 rounded mr-0 ml-0 mb-4" },
            [
              _vm._m(0),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("validation-provider", {
                    attrs: {
                      "custom-messages": {
                        required: "El campo es requerido."
                      },
                      rules: "required"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors, validate }) {
                            return [
                              _c("custom-text-area", {
                                attrs: {
                                  "count-classes": ["d-block", "small-counter"],
                                  "custom-error-msg": errors[0],
                                  error: errors[0],
                                  label: "Comentario:",
                                  maxlength: 3000,
                                  "show-char-count": ""
                                },
                                model: {
                                  value: _vm.comment,
                                  callback: function($$v) {
                                    _vm.comment = $$v
                                  },
                                  expression: "comment"
                                }
                              }),
                              _c(
                                "div",
                                { staticClass: "text-right mt-4" },
                                [
                                  _c(
                                    "action-button",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        i: "fas fa-times-circle",
                                        variant: "outline-danger"
                                      },
                                      on: { click: _vm.onCancel }
                                    },
                                    [_vm._v(" Cancelar ")]
                                  ),
                                  _c(
                                    "action-button",
                                    {
                                      attrs: {
                                        i: "fas fa-save",
                                        variant: "success"
                                      },
                                      on: {
                                        click: () =>
                                          _vm.applyAction(
                                            _vm.ACTIONS.Denie,
                                            validate
                                          )
                                      }
                                    },
                                    [_vm._v(" Guardar ")]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3018046189
                    )
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c("filter-manager", {
        ref: "filterRef",
        staticClass: "mb-4",
        attrs: { filters: _vm.filtersConfig },
        on: {
          search: function($event) {
            return _vm.onSearchHandler()
          }
        },
        model: {
          value: _vm.filter.model,
          callback: function($$v) {
            _vm.$set(_vm.filter, "model", $$v)
          },
          expression: "filter.model"
        }
      }),
      _vm.showChecks
        ? _c("div", { staticClass: "row my-3" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("checkbox", {
                  staticClass: "d-flex justify-content-end text-green",
                  attrs: {
                    "checked-bg-color": "bg-success",
                    icon: "fal fa-check",
                    text: _vm.allCheckedText
                  },
                  on: { input: _vm.checkAll },
                  model: {
                    value: _vm.allChecked,
                    callback: function($$v) {
                      _vm.allChecked = $$v
                    },
                    expression: "allChecked"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c("custom-separator", {
        staticClass: "my-4",
        attrs: { text: "Resultado" }
      }),
      _vm.results.length == 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No cuenta con información disponible." }
          })
        : _vm._e(),
      _vm._l(_vm.results, function(item) {
        return _c("result-row", {
          key: item.id,
          attrs: { checkable: _vm.showChecks, model: item },
          on: { check: _vm.onCheckItem, refresh: _vm.onSearchHandler }
        })
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": "" },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 my-3" }, [
      _c("i", { staticClass: "fas fa-times-circle text-red" }),
      _c("strong", { staticClass: "ml-2" }, [_vm._v(" Denegar ")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }